<template>
    <div>

        <el-form :model="from" :rules="rules" ref="from" style="padding: 0 10%;" label-width="100px">
            <el-form-item label="物品名称" prop="goods_name">
                <el-input v-model="from.goods_name" placeholder="请输入物品名称" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="物品编号" prop="goods_no">
                <el-input v-model="from.goods_no" placeholder="请输入物品编号" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="物品类型" prop="type_id">
                <el-select v-model="from.type_id" placeholder="请选择物品类型" clearable style="width:100%">
                    <el-option v-for="item in lxList" :key="item.id" :label="item.data"
                        :value="item.id">
                    </el-option>
			    </el-select>
            </el-form-item>
            <el-form-item label="规格型号" prop="goods_model">
                <el-input v-model="from.goods_model" placeholder="请输入规格型号" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="物品数量" prop="model_quantity">
                <el-input v-model="from.model_quantity" placeholder="请输入颜色" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="颜色" prop="model_colour">
                <el-input v-model="from.model_colour" placeholder="请输入颜色" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="重量" prop="model_weight">
                <el-input v-model="from.model_weight" placeholder="请输入重量" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="品牌" prop="model_brand">
                <el-input v-model="from.model_brand" placeholder="请输入品牌" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center;" label-width="0px">
                <el-button type="primary" @click="Add" v-show="from.id == null || from.id == ''"
                    style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
            </el-form-item>
            <el-form-item style="text-align: center;" label-width="0px">
                <el-button type="primary" @click="Update" v-show="from.id != null && from.id != ''"
                    style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">修改</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data() {
            return {
                // 物品类型
                lxList:[],
            };
        },
        methods: {
            async Add(){
                var url = 'GoodS/insertGoodS';
				var record = {
                    goods_name:this.from.goods_name,
                    goods_no:this.from.goods_no,
                    type_id:this.from.type_id,
                    goods_model:this.from.goods_model,
                    model_colour:this.from.model_colour,
                    model_brand:this.from.model_brand,
                    model_weight:this.from.model_weight,
                    model_quantity:this.from.model_quantity,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.$parent.$parent.Return();
						this.trash();
					} else {
						this.$message.warning(data);
					}
				}
            },
            async Update(){
                var url = 'GoodS/updateGoodS';
				var record = {
                    id:this.from.id,
                    goods_name:this.from.goods_name,
                    goods_no:this.from.goods_no,
                    type_id:this.from.type_id,
                    goods_model:this.from.goods_model,
                    model_colour:this.from.model_colour,
                    model_brand:this.from.model_brand,
                    model_weight:this.from.model_weight,
                    model_quantity:this.from.model_quantity,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.$parent.$parent.Return();
						this.trash();
					} else {
						this.$message.warning(data);
					}
				}
            },
        },
        async created() {
            this.from = this.$parent.$parent.from;
            //物品类型
            var lxList = await this.$globals.AxiosPost("/dictionaries/selectFind", {
            data_grouping: "article_type"
            });
            this.lxList = lxList.data;
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// WpGl_add.vue?5577cf69